import React, { useState } from "react";
import { Button, Typography, Grid, Card, Select, MenuItem, Switch, FormControlLabel } from "@mui/material";

export const SpeechTest = () => {
  const [transcribedText, setTranscribedText] = useState<string | null>(null);
  const [isListening, setIsListening] = useState<boolean>(false);
  const [language, setLanguage] = useState("en-US");
  const [isSpeaking, setIsSpeaking] = useState<boolean>(false); // 🔥 読み上げON/OFF用

  const startListening = () => {
    if (!("webkitSpeechRecognition" in window || "SpeechRecognition" in window)) {
      alert("お使いのブラウザは音声認識をサポートしていません。");
      return;
    }

    const recognition = new (window as any).webkitSpeechRecognition() || new (window as any).SpeechRecognition();
    recognition.lang = language;
    recognition.interimResults = false;
    recognition.continuous = false;

    recognition.onstart = () => setIsListening(true);
    recognition.onend = () => setIsListening(false);

    recognition.onresult = (event: any) => {
      const speech = event.results[0][0].transcript;
      setTranscribedText(speech);
      console.log("音声認識:", speech);

      // **🔥 トグルがONのときだけ読み上げ**
      if (isSpeaking) {
        const synth = window.speechSynthesis;
        const utterance = new SpeechSynthesisUtterance(speech);
        utterance.lang = language;
        synth.speak(utterance);
      }
    };

    recognition.start();
  };

  return (
    <Grid container justifyContent="center" alignItems="center" style={{ minHeight: "100vh" }}>
      <Card style={{ padding: "20px", maxWidth: "500px" }}>
        <Typography variant="h5" align="center">🎤 音声認識テスト</Typography>

        {/* 🔥 言語選択 */}
        <Select value={language} onChange={(e) => setLanguage(e.target.value)} fullWidth style={{ marginBottom: "10px" }}>
          <MenuItem value="en-US">🇺🇸 English</MenuItem>
          <MenuItem value="ja-JP">🇯🇵 日本語</MenuItem>
        </Select>

        {/* 🔥 読み上げON/OFFトグル */}
        <FormControlLabel
          control={<Switch checked={isSpeaking} onChange={() => setIsSpeaking(!isSpeaking)} />}
          label="🔊 読み上げON/OFF"
        />

        {/* 🎤 音声認識ボタン */}
        <Button fullWidth variant="contained" color="primary" onClick={startListening} disabled={isListening} style={{ marginTop: "10px" }}>
          🎙 {isListening ? "リスニング中..." : "英語を話す"}
        </Button>

        {/* 🎤 認識結果 */}
        {transcribedText && <Typography style={{ marginTop: "10px" }}>🎤 認識: {transcribedText}</Typography>}
      </Card>
    </Grid>
  );
};
